export default "__VITE_PUBLIC_ASSET__210e4d8b__"